import controller from './kform-builder-toolbar.controller';
import template from './kform-builder-toolbar.html';
import './kform-builder-toolbar.scss';

export default {
	controller,
	template,
	bindings:     {
		ctrl: '<',
	},
};
